import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import {MAT_DATE_FNS_FORMATS, MatDateFnsModule} from "@angular/material-date-fns-adapter";

const IMPORTS = [
  MatButtonModule,
  MatCheckboxModule,
  MatIconModule,
  MatRippleModule,
  MatProgressBarModule,
  MatTooltipModule,
  MatFormFieldModule,
  MatInputModule,
  MatAutocompleteModule,
  MatSlideToggleModule,
  MatButtonToggleModule,
  MatProgressSpinnerModule,
  MatChipsModule,
  MatExpansionModule,
  MatSelectModule,
  MatTabsModule,
  MatDividerModule,
  MatCardModule,
  MatStepperModule,
  MatDialogModule,
  MatSnackBarModule,
  MatRadioModule,
  MatRippleModule,
  MatSliderModule,
  MatListModule,
  MatDatepickerModule,
  MatDateFnsModule,
  MatNativeDateModule,
  MatTableModule
];

@NgModule({
  imports: IMPORTS,
  exports: IMPORTS,
  providers: [
    {
      provide: DateAdapter,
      useClass: MatDateFnsModule
    },
    {
      provide: MAT_DATE_FNS_FORMATS,
      useValue: {
        parse: {
          dateInput: 'dd-MM-yyyy'
        },
        display: {
          dateInput: 'dd-MM-yyyy',
          monthYearLabel: 'dd-MM-yyyy',
          dateA11yLabel: 'dd-MM-yyyy',
          monthYearA11yLabel: 'dd-MM-yyyy'
        }
      }
    }
  ]
})
export class MaterialModule {
}
